export const CHECK_LABEL_MAX_LENGTH = 80;

export const cropWithEllipsis = (name: string, max: number = 38) => {
  if (name.length > max) {
    return name.slice(0, max - 3) + "…";
  }

  return name;
};
